export default __webpack_public_path__ + "static/media/icons.2c894168.svg";